import { render, staticRenderFns } from "./compdraw.vue?vue&type=template&id=3bbb06aa&scoped=true&"
import script from "./compdraw.vue?vue&type=script&lang=js&"
export * from "./compdraw.vue?vue&type=script&lang=js&"
import style0 from "./compdraw.vue?vue&type=style&index=0&id=3bbb06aa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bbb06aa",
  null
  
)

export default component.exports